export default {
  dashboardTitle: "Dashboard",
  welcomeMessage: "Welcome back!",
  usersCount: "Users",
  pendingOrders: "Pending Orders",
  invoices: "Invoices",
  lowStock: "Low Stock",
  ordersChartTitle: "Orders in Last 10 Days"
}